import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';

import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Portlet, PortletContent } from '../../../../../components';
import { BeneficiosMGMParametrosTablePagination } from './BeneficiosMGMParametrosTablePagination';
import { BeneficiosMGMTableRow } from './BeneficiosMGMTableRow';
import { BeneficiosMGMTableRowStyles } from '../BeneficiosMGM.style';
import BeneficiosSortButton from '../BeneficiosSortButton';

const useStyles = makeStyles({
  ...BeneficiosMGMTableRowStyles,
  tableWrapper: {
    overflowX: 'auto',
    width: '100%',
  },
});

export const BeneficiosMGMParametrosTable = props => {
  const classes = useStyles();
  const {
    data: dataMGM,
    total,
    currentPage,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    setSorts,
    sorts,
  } = props;
  const rootClassName = cls(classes.root);

  return (
    <Portlet className={rootClassName}>
      <PortletContent noPadding>
        <div className={classes.tableWrapper}>
          <Table width="100%" className={classes.tableContainer}>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell rowSpan={2} className={classes.tableCell}>
                  <Typography variant="body2">
                    CRM ID
                    <BeneficiosSortButton
                      column="created_on"
                      sortState={sorts}
                      onSort={newSort => setSorts({ ...sorts, ...newSort })}
                    />
                  </Typography>
                </TableCell>

                <TableCell rowSpan={2} className={classes.tableCell}>
                  <Typography variant="body2">Origem</Typography>
                </TableCell>
                <TableCell colSpan={4} align="center" className={classes.headerIndicado}>
                  <strong>Indicado</strong>
                </TableCell>
                {/* Cabeçalho agrupado para Indicador */}
                <TableCell colSpan={4} align="center" className={classes.headerIndicador}>
                  <strong>Indicador</strong>
                </TableCell>
              </TableRow>
              <TableRow className={classes.rowShadow}>
                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Nome</Typography>
                </TableCell>

                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Status</Typography>
                </TableCell>

                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Motivo</Typography>
                </TableCell>

                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Valor</Typography>
                </TableCell>

                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Nome</Typography>
                </TableCell>

                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Status </Typography>
                </TableCell>

                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Motivo</Typography>
                </TableCell>

                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Valor</Typography>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {!dataMGM || dataMGM.length === 0 ? (
                <TableRow width="100%" className={classes.tr}>
                  <TableCell className={classes.tableCell} width="100%" colSpan={10}>
                    Ops. Não encontramos nada.
                  </TableCell>
                </TableRow>
              ) : (
                dataMGM.map(row => (
                  <BeneficiosMGMTableRow
                    key={row?.crmOpportunityId || `row-${Math.random()}`}
                    dataMGM={row}
                    classes={classes}
                  />
                ))
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={total}
                  page={currentPage - 1}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage="Registros por página"
                  onPageChange={() => {}}
                  rowsPerPageOptions={[10, 25, 50, 100, 500]}
                  ActionsComponent={() => (
                    <BeneficiosMGMParametrosTablePagination
                      total={total}
                      onChangePage={handleChangePage}
                      page={currentPage}
                      rowsPerPage={rowsPerPage}
                    />
                  )}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </PortletContent>
    </Portlet>
  );
};

BeneficiosMGMParametrosTable.propTypes = {
  data: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangeRowsPerPage: PropTypes.func.isRequired,
  setSorts: PropTypes.func.isRequired,
  sorts: PropTypes.object.isRequired,
};
